import request from '@/utils/axios';

const attachmentHelper = async (area, id, filepath, isLoggedIn, userinfo, isLoading, loginWithRedirect, secure) => {
  if (!isLoading) {
    if (!secure) {
      window.location.href = `${process.env.NEW_API_ROOT}file/downloadnsfile?id=${id}&area=${area}`;
      return;
    }

    if (secure && isLoggedIn) {
      const response = await request({
        url: 'attachment/filesecuritypass',
        method: 'POST',
        data: {
          FileId: id,
          FileArea: area,
          PersonId: userinfo.PersonID,
          filepath,
        },
        triggerLoad: false,
      });
      const fileUrl = response.data.fileUrl;
      window.location.href = fileUrl;
      return;
    } else {
      loginWithRedirect({
        authorizationParams: {
          redirect_uri: '/',
        },
      });
      return;
    }
  }
};

export default attachmentHelper;